export default "__VITE_ASSET__B9bJWl5M__"